import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=5a0cae2a&scoped=true"
import script from "./AddModal.vue?vue&type=script&lang=js"
export * from "./AddModal.vue?vue&type=script&lang=js"
import style0 from "./AddModal.vue?vue&type=style&index=0&id=5a0cae2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0cae2a",
  null
  
)

export default component.exports